import {
  BankAccountOwnerType,
  bankAccountSchema,
  schemes,
  zSchema,
} from "@zeal/common";

export const createBankAccountRequestSchema = zSchema.object({
  account_number: schemes.bankAccountNumber(),
  companyID: schemes.companyID(),
  institution_name: zSchema.string().nullish(),
  is_primary: zSchema.boolean(),
  owner_type: zSchema
    .nativeEnum(BankAccountOwnerType)
    .optional()
    .default(BankAccountOwnerType.Worker),
  routing_number: schemes.routingNumber(),
  type: schemes.bankAccountType(),
  id: schemes.mongoObjectId(),
});

export type TCreateBankAccountRequestSchema = zSchema.infer<
  typeof createBankAccountRequestSchema
>;

export const createBankAccountResponseSchema = bankAccountSchema.extend({
  bankAccountID: schemes.uuid(),
});

export type TCreateBankAccountResponseSchema = zSchema.infer<
  typeof createBankAccountResponseSchema
>;
